import React from 'react';
var stores = [{
  name: 'Spotify',
  rate: 0.00361,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("g", {
    id: "Digital stores/Spotify",
    clipPath: "url(#clip0_2077_5015)"
  },
  /*#__PURE__*/
  React.createElement("path", {
    id: "Vector",
    d: "M18.6565 12.7533C14.9536 10.4768 9.54255 9.83686 5.18642 11.1588C4.69226 11.3091 4.4135 11.8305 4.56182 12.3257C4.71182 12.8192 5.23347 13.098 5.72799 12.9488C9.54123 11.7909 14.4549 12.3654 17.6778 14.3471C18.1174 14.6177 18.7199 14.4794 18.9599 14.0393V14.0396C19.2 13.5999 19.0961 13.0238 18.6565 12.7533ZM17.5007 17.3061L17.5003 17.3065C17.7174 16.9543 17.6047 16.4945 17.2528 16.2777C14.091 14.3448 10.1718 13.8951 5.6027 14.9405C5.19998 15.0319 4.94882 15.4332 5.0399 15.8357C5.13218 16.2381 5.53323 16.4906 5.93547 16.398C10.1105 15.4442 13.6565 15.833 16.4729 17.5555C16.5567 17.6067 16.6498 17.6409 16.7469 17.6561C16.844 17.6713 16.9431 17.6672 17.0385 17.644C17.134 17.6209 17.224 17.5791 17.3033 17.5211C17.3826 17.4631 17.4497 17.3901 17.5007 17.3061ZM20.6322 10.2444C20.9478 9.71195 20.7728 9.02291 20.2402 8.70635C15.7892 6.06311 8.74503 5.81411 4.5083 7.10123C3.91574 7.28147 3.58166 7.90811 3.7607 8.50139C3.9401 9.09431 4.56722 9.42887 5.15942 9.24935C8.85147 8.12843 15.2286 8.33963 19.0953 10.6365C19.6268 10.9535 20.3171 10.7779 20.6322 10.2444Z",
    fill: "white"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    id: "Vector_2",
    d: "M12 -0.000372422V-0.000732422C5.39997 -0.000732422 0.00537109 5.37179 0.00537109 11.9989C0.00537109 18.6271 5.37549 23.9993 12.0001 23.9993C18.6251 23.9993 23.9943 18.6271 23.9943 11.9989C23.9943 5.37215 18.6 -0.000372422 12 -0.000372422Z",
    fill: "#24CF5F"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    id: "Vector_3",
    d: "M17.6779 14.3472C14.4549 12.3655 9.5413 11.7911 5.72806 12.9489C5.23354 13.0981 4.71178 12.8193 4.5619 12.3258C4.41358 11.8307 4.69234 11.3093 5.1865 11.1589C9.5425 9.83687 14.9537 10.4768 18.6565 12.7535C19.0961 13.0239 19.2 13.6001 18.96 14.0397V14.0394C18.72 14.4795 18.1175 14.6178 17.6779 14.3472ZM5.9353 16.398C5.53294 16.4906 5.1319 16.2381 5.03974 15.8357C4.94866 15.4332 5.19982 15.0319 5.60254 14.9405C10.1717 13.8953 14.0909 14.3448 17.2526 16.2777C17.6047 16.4945 17.7173 16.9543 17.5002 17.3065L17.5005 17.3061C17.4495 17.3901 17.3824 17.4632 17.3031 17.5212C17.2238 17.5791 17.1339 17.6209 17.0384 17.6441C16.9429 17.6672 16.8438 17.6713 16.7467 17.6561C16.6497 17.6409 16.5566 17.6067 16.4727 17.5555C13.6565 15.833 10.1105 15.4443 5.9353 16.398ZM19.0952 10.6368C15.2286 8.33987 8.85142 8.12855 5.15938 9.24959C4.56718 9.42911 3.94006 9.09455 3.76066 8.50163C3.58174 7.90835 3.9157 7.28171 4.50826 7.10147C8.74498 5.81435 15.789 6.06335 20.24 8.70659C20.7726 9.02303 20.9477 9.71219 20.6321 10.2446C20.3171 10.778 19.6267 10.9536 19.0952 10.6368Z",
    fill: "white"
  })),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("clipPath", {
    id: "clip0_2077_5015"
  },
  /*#__PURE__*/
  React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Apple Music',
  rate: 0.00893,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("g", {
    clipPath: "url(#clip0_2077_5024)"
  },
  /*#__PURE__*/
  React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7.50722V6.64682C24 6.40682 24 6.16682 23.9892 5.92682C23.9824 5.39887 23.9359 4.87218 23.85 4.35122C23.7613 3.82942 23.5951 3.32383 23.3568 2.85122C22.8731 1.90119 22.101 1.12868 21.1512 0.644421C20.6792 0.406674 20.1745 0.240455 19.6536 0.151221C19.1322 0.0653833 18.6051 0.0188523 18.0768 0.0120207C17.8368 0.0048207 17.5968 0.0024207 17.3568 0.0012207H6.6468C6.4068 0.0012207 6.1668 0.0012207 5.9268 0.0120207C5.39725 0.0186718 4.86896 0.0652035 4.3464 0.151221C3.82526 0.240117 3.32043 0.406776 2.8488 0.645621C1.90002 1.12915 1.12844 1.90031 0.6444 2.84882C0.406125 3.32101 0.239883 3.82621 0.1512 4.34762C0.0653626 4.86899 0.0188315 5.39608 0.012 5.92442C0.0048 6.16442 0.0024 6.40442 0.0012 6.64442C0.0004 6.93482 0 7.22242 0 7.50722V17.352C0 17.592 0 17.832 0.0108 18.072C0.0175772 18.6004 0.0641086 19.1275 0.15 19.6488C0.238683 20.1702 0.404925 20.6754 0.6432 21.1476C1.12724 22.0961 1.89882 22.8673 2.8476 23.3508C3.31953 23.589 3.82425 23.7556 4.3452 23.8452C4.86652 23.9313 5.39365 23.9774 5.922 23.9832C6.162 23.9904 6.402 23.9928 6.642 23.994H17.3424C17.5824 23.994 17.8224 23.994 18.0624 23.9832C18.5907 23.9775 19.1179 23.9314 19.6392 23.8452C20.1607 23.7561 20.6659 23.5895 21.138 23.3508C22.0861 22.8668 22.8571 22.0957 23.3412 21.1476C23.5799 20.6755 23.7465 20.1703 23.8356 19.6488C23.9216 19.1275 23.9678 18.6004 23.9736 18.072C23.9808 17.832 23.9832 17.592 23.9844 17.352V7.50722H24Z",
    fill: "url(#paint0_linear_2077_5024)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9668 3.66729C16.9092 3.66729 16.3932 3.76329 16.3308 3.77649L9.19798 5.21649C9.03523 5.24452 8.88214 5.31302 8.75278 5.41569C8.61843 5.53523 8.53296 5.70018 8.51278 5.87889C8.50186 5.95841 8.49664 6.03862 8.49718 6.11889V15.0469C8.51642 15.254 8.46016 15.4611 8.33878 15.6301C8.20436 15.7806 8.01867 15.8756 7.81798 15.8965L7.35238 15.9901C6.9037 16.0641 6.46211 16.1761 6.03238 16.3249C5.73811 16.4303 5.47176 16.6014 5.25358 16.8253C4.91173 17.1936 4.72976 17.6824 4.74753 18.1847C4.76529 18.6869 4.98135 19.1616 5.34838 19.5049C5.59067 19.73 5.89054 19.8837 6.21478 19.9489C6.57478 20.0209 6.94798 19.9957 7.50118 19.8841C7.79451 19.8294 8.07648 19.7256 8.33518 19.5769C8.59532 19.4238 8.81924 19.2163 8.99158 18.9685C9.16324 18.721 9.28211 18.4407 9.34078 18.1453C9.39919 17.8546 9.42575 17.5585 9.41998 17.2621V9.52089C9.41998 9.10569 9.53998 8.99649 9.87238 8.92089C9.87238 8.92089 15.8016 7.72089 16.0788 7.67169C16.464 7.59729 16.6464 7.70769 16.6464 8.11209V13.3921C16.6464 13.6009 16.6464 13.8133 16.5012 13.9921C16.3671 14.1421 16.1818 14.2367 15.9816 14.2573L15.5148 14.3521C15.0662 14.426 14.6246 14.5375 14.1948 14.6857C13.9009 14.7919 13.6347 14.9629 13.416 15.1861C13.2425 15.3663 13.1071 15.5796 13.0177 15.8132C12.9283 16.0468 12.8868 16.296 12.8957 16.546C12.9045 16.7959 12.9635 17.0416 13.0692 17.2683C13.1749 17.495 13.325 17.6982 13.5108 17.8657C13.7537 18.0892 14.0535 18.2415 14.3772 18.3061C14.7372 18.3781 15.1116 18.3517 15.6648 18.2413C15.9575 18.1877 16.2391 18.0851 16.4976 17.9377C16.7577 17.7851 16.9816 17.5779 17.154 17.3305C17.3255 17.0829 17.4443 16.8027 17.5032 16.5073C17.5577 16.2158 17.5802 15.9193 17.5704 15.6229V4.29729C17.5692 3.88689 17.3532 3.63369 16.9668 3.66729Z",
    fill: "white"
  })),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint0_linear_2077_5024",
    x1: "12",
    y1: "23.9064",
    x2: "12",
    y2: "0.517221",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#FA233B"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#FB5C74"
  })),
  /*#__PURE__*/
  React.createElement("clipPath", {
    id: "clip0_2077_5024"
  },
  /*#__PURE__*/
  React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Youtube Music',
  rate: 0.00499,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("g", {
    clipPath: "url(#clip0_2077_5033)"
  },
  /*#__PURE__*/
  React.createElement("path", {
    d: "M0 11.976C0 5.352 5.364 0 12 0C18.624 0 24 5.364 24 11.988C24 18.636 18.612 24 11.964 24C5.34 23.988 0 18.624 0 11.976ZM11.988 18.312C15.468 18.312 18.3 15.492 18.312 12.012C18.324 8.544 15.492 5.688 12.024 5.676C8.544 5.664 5.664 8.532 5.676 12C5.688 15.468 8.52 18.312 11.988 18.312Z",
    fill: "#F9061B"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M11.988 18.3119C8.52 18.3119 5.676 15.4799 5.676 11.9999C5.664 8.53193 8.556 5.65193 12.024 5.67593C15.492 5.68793 18.324 8.54393 18.312 12.0119C18.3 15.4919 15.468 18.3119 11.988 18.3119ZM11.988 17.6999C15.132 17.6999 17.688 15.1559 17.7 12.0239C17.712 8.85593 15.168 6.29993 12 6.29993C8.856 6.29993 6.3 8.83193 6.3 11.9639C6.288 15.1319 8.832 17.6999 11.988 17.6999Z",
    fill: "white"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M11.988 17.7001C8.83197 17.7001 6.28797 15.1441 6.29997 11.9641C6.31197 8.82009 8.85597 6.28809 12 6.30009C15.156 6.30009 17.7 8.85609 17.7 12.0241C17.688 15.1561 15.132 17.7001 11.988 17.7001ZM15.192 11.8561C13.368 10.8241 11.628 9.85209 9.82797 8.83209V15.1441C11.64 14.0521 13.368 12.9841 15.192 11.8561Z",
    fill: "#F9061B"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M15.192 11.856C13.368 12.972 11.64 14.04 9.828 15.156V8.84399C11.628 9.85199 13.368 10.824 15.192 11.856Z",
    fill: "white"
  })),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("clipPath", {
    id: "clip0_2077_5033"
  },
  /*#__PURE__*/
  React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Amazon Music',
  rate: 0.00573,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "23",
    height: "24",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("g", {
    clipPath: "url(#clip0_2077_5043)"
  },
  /*#__PURE__*/
  React.createElement("path", {
    d: "M4.19695 15.2115V17.7416C4.19695 18.0595 4.20224 18.3781 4.19695 18.6967C4.1912 18.9552 4.15521 18.9887 3.90945 18.9974C3.76754 19.0022 3.62563 19.005 3.48441 18.9974C3.27856 18.9859 3.24912 18.9504 3.23475 18.728C3.23015 18.6599 3.23475 18.5916 3.23475 18.5234V15.7601C3.22946 14.9735 2.93793 14.6945 2.20182 14.8214C1.91685 14.8698 1.64418 14.9988 1.36703 15.0942C1.19637 15.1523 1.15267 15.2736 1.15394 15.4605C1.16371 16.5171 1.15911 17.5752 1.15854 18.6312C1.15854 18.9872 1.14934 18.9948 0.812734 18.9981H0.453129C0.291669 19.0037 0.207949 18.93 0.207949 18.7574V14.5621C0.20364 14.4939 0.204948 14.4255 0.211859 14.3575C0.220369 14.3043 0.247164 14.2149 0.277294 14.2116C0.477054 14.1834 0.678429 14.1695 0.880009 14.1699C1.03491 14.1699 1.05067 14.3186 1.07608 14.4428C1.08528 14.4865 1.09644 14.5301 1.11208 14.5943C1.30815 14.4865 1.49514 14.3753 1.688 14.2845C2.08155 14.0876 2.51481 13.9926 2.95104 14.0076C3.40138 14.0307 3.77605 14.1999 4.01985 14.6487C4.10288 14.6037 4.17809 14.5669 4.2487 14.5226C4.71215 14.2334 5.20504 14.0294 5.75221 14.0124C5.96911 14.0035 6.18608 14.0278 6.39621 14.0846C6.91912 14.2334 7.22502 14.7218 7.22962 15.4005C7.23617 16.3671 7.22962 17.333 7.22962 18.2989V18.6741C7.22306 18.96 7.19569 18.99 6.93349 18.9961H6.574C6.30145 18.9893 6.27385 18.9648 6.27132 18.6837C6.26672 18.2061 6.27132 17.7287 6.27132 17.2512V15.6823C6.27076 15.558 6.25558 15.4343 6.22613 15.3139C6.14057 14.9729 5.95944 14.8139 5.62468 14.8009C5.10051 14.7831 4.63499 14.9421 4.19707 15.2115H4.19695ZM4.77103 5.26727C5.18618 4.52447 6.16863 4.42967 6.62173 5.31287C6.87208 4.82591 7.25975 4.62323 7.77552 4.69895C8.24093 4.76723 8.56787 5.11715 8.60444 5.60615C8.62399 5.86619 8.61031 6.12875 8.61031 6.38999V8.53811C8.61031 8.82803 8.59329 8.84303 8.31476 8.84855C8.17296 8.84855 8.03105 8.85263 7.88995 8.84855C7.6427 8.84099 7.61602 8.81578 7.61533 8.54566C7.61211 7.84102 7.61533 7.13567 7.61533 6.43103C7.61687 6.30633 7.61053 6.18165 7.59635 6.05782C7.56174 5.78495 7.47549 5.68942 7.26952 5.66218C7.17189 5.6456 7.07176 5.66393 6.98537 5.7142C6.89899 5.76448 6.83142 5.84375 6.79365 5.93915C6.74501 6.08898 6.72049 6.24619 6.72109 6.40439C6.71315 7.0981 6.72109 7.79123 6.71706 8.48495C6.71706 8.83355 6.70338 8.8465 6.36677 8.84914H5.94242C5.78165 8.84914 5.70058 8.76803 5.70127 8.59955V8.22431V6.34907C5.7038 6.22427 5.69425 6.09947 5.67252 5.97671C5.66011 5.8917 5.6202 5.81369 5.55943 5.75562C5.49866 5.69756 5.42068 5.66293 5.33844 5.65751C5.14225 5.63831 4.97562 5.70995 4.90949 5.89067C4.8511 6.04916 4.81906 6.21688 4.81473 6.38663C4.80438 7.05719 4.80956 7.72775 4.80956 8.39831V8.6371C4.80956 8.77343 4.74412 8.84855 4.61348 8.84855C4.42776 8.84855 4.24272 8.85334 4.0578 8.84855C3.84137 8.84171 3.81193 8.81434 3.80998 8.59054C3.8048 8.13634 3.80998 7.68131 3.80998 7.22639V5.07755C3.80998 4.77395 3.83229 4.75631 4.12968 4.75151H4.26043C4.73573 4.75151 4.73573 4.75151 4.77103 5.26727ZM11.5083 18.6053C11.3448 18.6973 11.1814 18.7867 11.0245 18.8781C10.5303 19.1639 9.99686 19.2308 9.44509 19.1748C9.18876 19.1461 8.94907 19.0284 8.76442 18.8407C8.57977 18.6529 8.46083 18.406 8.42665 18.1393C8.39714 17.9375 8.38161 17.7336 8.38019 17.5295C8.37559 16.5745 8.38019 15.6195 8.38019 14.6645C8.38019 14.5745 8.36582 14.4749 8.39721 14.3957C8.42861 14.3166 8.50646 14.2757 8.56511 14.2177C8.57109 14.2122 8.58616 14.2177 8.59731 14.2177C9.28685 14.1222 9.33918 14.1692 9.33918 14.8903C9.33918 15.7429 9.347 16.5956 9.33918 17.4469C9.33136 18.2983 9.81769 18.5303 10.4505 18.3849C10.7222 18.3102 10.9886 18.2163 11.2481 18.1039C11.4285 18.0356 11.4978 17.9027 11.4952 17.6864C11.4828 16.6754 11.4899 15.6638 11.4899 14.6522V14.4141C11.4856 14.3887 11.487 14.3627 11.494 14.3379C11.501 14.3132 11.5135 14.2905 11.5303 14.2716C11.5472 14.2528 11.568 14.2383 11.5912 14.2293C11.6144 14.2203 11.6392 14.217 11.6638 14.2197C11.8488 14.2157 12.0345 14.2157 12.2195 14.2197C12.3502 14.2197 12.4157 14.3003 12.4157 14.4373V18.8352C12.4215 18.9974 12.3398 19.0602 12.1934 19.052H12.128C11.6501 19.0644 11.6501 19.0644 11.5083 18.6053ZM11.4246 8.33147C11.0591 8.74067 10.6225 8.85598 10.1315 8.80894C9.69223 8.76671 9.39093 8.50199 9.26926 8.05859C9.10446 7.45895 9.35493 6.70523 10.059 6.48971C10.3787 6.39011 10.7126 6.35327 11.0454 6.28847C11.1255 6.27806 11.206 6.27189 11.2866 6.26999C11.2912 6.17447 11.2997 6.09803 11.2977 6.02231C11.2906 5.73311 11.1984 5.58167 10.9964 5.52035C10.877 5.47769 10.7473 5.47764 10.6278 5.52021C10.5082 5.56278 10.4057 5.64556 10.3361 5.75555C10.3015 5.81231 10.2825 5.88047 10.2446 5.93507C10.2133 5.97875 10.1629 6.0415 10.1243 6.03947C9.89744 6.02906 9.67146 6.00353 9.44774 5.96303C9.32549 5.93915 9.33331 5.82046 9.36206 5.71198C9.40362 5.53465 9.4834 5.36955 9.59534 5.22924C9.70728 5.08894 9.84842 4.97714 10.008 4.90235C10.2641 4.77619 10.5423 4.70602 10.8253 4.69616C11.1084 4.68629 11.3904 4.73694 11.654 4.84499C12.0463 4.99919 12.2737 5.29595 12.2881 5.74259C12.3045 6.26387 12.3202 6.78503 12.3209 7.30619C12.3209 7.55243 12.3575 7.77347 12.4973 7.98011C12.6373 8.18687 12.6222 8.22503 12.4581 8.38187C12.3378 8.49719 12.2104 8.60363 12.0842 8.71139C11.9581 8.81915 11.8482 8.80618 11.741 8.68414C11.6462 8.57218 11.5488 8.46791 11.4246 8.33135V8.33147ZM11.3298 6.81095C11.0513 6.87443 10.8474 6.90167 10.6571 6.96983C10.4198 7.05443 10.2943 7.25975 10.2721 7.51559C10.2564 7.69847 10.2943 7.88735 10.4557 7.99859C10.5267 8.05361 10.6132 8.08245 10.7016 8.08059C10.79 8.07872 10.8753 8.04624 10.9441 7.98827C11.0717 7.88637 11.1698 7.74977 11.2278 7.59347C11.2938 7.37027 11.2926 7.12811 11.3298 6.81023V6.81095ZM2.22988 8.33147C2.15869 8.38943 2.08877 8.44126 2.02403 8.50066C1.64223 8.84855 1.18855 8.86907 0.729704 8.77343C0.428289 8.71271 0.211859 8.50066 0.0942139 8.19227C-0.167296 7.49782 0.130209 6.73595 0.805489 6.49511C1.13232 6.37991 1.48341 6.34906 1.82404 6.28294C1.90473 6.27252 1.98587 6.26635 2.06715 6.26446C2.07175 6.17039 2.08026 6.09407 2.07831 6.01763C2.07106 5.70923 1.98481 5.57903 1.7455 5.50595C1.63044 5.46959 1.50717 5.4733 1.3943 5.51651C1.28144 5.55972 1.18512 5.64009 1.1199 5.74546C1.09253 5.8069 1.06148 5.86667 1.02709 5.92415C0.987879 5.97335 0.927044 6.03875 0.877364 6.03743C0.670991 6.02969 0.465299 6.00825 0.261539 5.97323C0.121699 5.94875 0.108589 5.83678 0.142629 5.7079C0.184185 5.53031 0.264018 5.36494 0.376054 5.22439C0.48809 5.08384 0.629375 4.97181 0.789159 4.89683C1.04093 4.77326 1.31386 4.70358 1.59186 4.69187C1.86986 4.68016 2.14729 4.72668 2.40778 4.82867C2.81247 4.98215 3.05558 5.27819 3.06938 5.74343C3.08433 6.25427 3.10204 6.76655 3.10135 7.27547C3.10135 7.53334 3.13539 7.76591 3.28305 7.98287C3.4138 8.17523 3.39747 8.22227 3.2321 8.38463C3.18438 8.43107 3.13401 8.47463 3.08433 8.52107C2.6862 8.87987 2.65101 8.87579 2.31693 8.44607C2.29014 8.41055 2.26461 8.37575 2.22999 8.33147H2.22988ZM2.11752 6.80543C1.82404 6.87371 1.6083 6.90299 1.41142 6.98147C1.17878 7.07495 1.06113 7.29107 1.05124 7.54499C1.04342 7.72643 1.08724 7.91531 1.26112 8.01359C1.33117 8.05935 1.41299 8.08159 1.49554 8.0773C1.57809 8.073 1.65738 8.04239 1.72273 7.98959C1.83577 7.89359 1.95871 7.76734 1.99919 7.62959C2.06715 7.39559 2.07302 7.14311 2.11752 6.80411V6.80543ZM20.9866 8.82131H20.006V4.80731C20.2675 4.72751 20.5251 4.77047 20.7806 4.77527C20.8885 4.77527 20.9526 4.86119 20.9565 4.97999C20.9598 5.06723 20.9669 5.15399 20.9749 5.28359C21.0265 5.21519 21.0539 5.18399 21.0768 5.14703C21.3835 4.67303 21.7254 4.61639 22.2862 4.73231C22.6444 4.80599 22.8589 5.09387 22.9301 5.46911C22.9705 5.68043 22.9924 5.89535 22.9955 6.11099C23.0034 6.90635 22.9994 7.70171 22.9955 8.49839C22.9955 8.81903 22.9739 8.83954 22.6615 8.84566H22.3019C21.975 8.84566 21.9672 8.83679 21.9665 8.50463V6.4255C21.9682 6.27861 21.9544 6.13196 21.9253 5.98823C21.8842 5.79791 21.7776 5.66146 21.571 5.64718C21.3886 5.6335 21.1834 5.73119 21.1252 5.92007C21.0506 6.15596 21.0066 6.40122 20.9944 6.64931C20.9768 7.23935 20.9886 7.83071 20.9886 8.42291L20.9866 8.82131ZM14.7147 19.1775C14.2792 19.2048 13.8435 19.128 13.4406 18.9531C13.3491 18.9135 13.2282 18.8297 13.2112 18.7485C13.188 18.581 13.192 18.4106 13.223 18.2444C13.223 18.2226 13.3537 18.1967 13.4191 18.2096C13.6851 18.2635 13.946 18.3535 14.2133 18.389C14.494 18.421 14.7765 18.4308 15.0586 18.4183C15.1724 18.4183 15.2874 18.3555 15.3973 18.3092C15.63 18.2117 15.7104 17.9967 15.7241 17.7635C15.7308 17.6601 15.7067 17.557 15.6551 17.4685C15.6034 17.38 15.5269 17.3103 15.4358 17.2689C15.2332 17.1618 15.0174 17.0814 14.807 16.9899C14.5069 16.8596 14.1938 16.7552 13.9087 16.5956C13.476 16.3521 13.2465 15.9695 13.2426 15.4359C13.2387 14.8357 13.5171 14.4367 14.0127 14.2081C14.7318 13.8745 15.4548 13.9803 16.1699 14.2559C16.2228 14.272 16.2683 14.3074 16.2983 14.3556C16.3283 14.4038 16.3407 14.4616 16.3334 14.5185V14.655C16.3334 15.0103 16.3131 15.0342 15.9751 14.9277C15.6409 14.8257 15.2936 14.7783 14.9455 14.7872C14.8581 14.7885 14.7709 14.7947 14.684 14.8057C14.3696 14.852 14.167 15.0253 14.1166 15.2832C14.0662 15.5411 14.1885 15.7777 14.4919 15.923C14.8364 16.0881 15.1939 16.2218 15.545 16.374C15.6849 16.434 15.8229 16.5008 15.9575 16.5725C16.8766 17.0629 16.7139 18.3535 16.1007 18.8051C15.8208 19.0224 15.4871 19.1516 15.1391 19.1775C14.9984 19.1864 14.8566 19.1775 14.7147 19.1775ZM16.1967 6.75851C16.1655 6.35463 16.2394 5.94946 16.4105 5.58575C16.6642 5.06807 17.0453 4.73783 17.6284 4.69895C18.2639 4.65335 18.7803 4.8709 19.0811 5.46298C19.5229 6.33202 19.5386 7.22699 19.0614 8.09135C18.7633 8.62811 18.277 8.87579 17.6919 8.84651C17.0852 8.81579 16.655 8.47943 16.4001 7.90511C16.2398 7.54716 16.1698 7.15245 16.1967 6.75839V6.75851ZM18.3501 6.79931C18.3292 6.54011 18.3155 6.29111 18.2848 6.04487C18.2692 5.93285 18.2365 5.82415 18.188 5.72291C18.156 5.65061 18.1065 5.58831 18.0443 5.5422C17.9821 5.49609 17.9094 5.46779 17.8334 5.46011C17.7575 5.45241 17.681 5.46555 17.6114 5.49824C17.5418 5.53093 17.4817 5.58203 17.4369 5.64647C17.3784 5.72754 17.3367 5.82049 17.3147 5.91935C17.202 6.47495 17.2069 7.04952 17.329 7.60295C17.3492 7.67927 17.3812 7.75162 17.4238 7.81715C17.5879 8.09878 17.8998 8.13839 18.103 7.88531C18.1917 7.77165 18.2527 7.63732 18.2809 7.49375C18.3152 7.26371 18.3383 7.03187 18.3501 6.79931ZM3.1746 9.39215C3.29156 9.14794 3.40012 9.26123 3.50143 9.30959C3.97535 9.53399 4.44018 9.7831 4.92398 9.98218C6.03948 10.4322 7.21248 10.7079 8.40503 10.8008C10.2355 10.9604 12.0005 10.6575 13.7107 9.98566C13.799 9.94333 13.8932 9.91571 13.9898 9.90382C14.025 9.90401 14.0596 9.9128 14.0909 9.92949C14.1223 9.94618 14.1494 9.97031 14.1702 9.99995C14.1805 10.0358 14.1823 10.0737 14.1755 10.1104C14.1687 10.1471 14.1534 10.1816 14.131 10.2108C14.0338 10.3015 13.9272 10.3806 13.8132 10.4467C12.9923 10.9788 12.096 11.3151 11.1553 11.5231C9.41281 11.919 7.59772 11.779 5.93 11.12C5.01195 10.7614 4.15825 10.2442 3.4046 9.59003C3.32755 9.52319 3.25372 9.45898 3.1746 9.39215ZM22.9281 14.9721C22.6451 14.9264 22.4 14.8971 22.1587 14.8459C21.8613 14.7831 21.5703 14.8296 21.288 14.9025C21.1001 14.943 20.9268 15.0374 20.7877 15.1753C20.6484 15.313 20.5489 15.4886 20.5003 15.6823C20.329 16.2721 20.3242 16.9008 20.4865 17.4933C20.6296 18.0221 20.9971 18.2915 21.5063 18.3603C21.8966 18.4065 22.2917 18.3749 22.6705 18.2669C22.9503 18.1932 22.989 18.2274 22.9975 18.5323C23.0053 18.9 22.989 18.9347 22.6576 19.0466C22.0538 19.2518 21.4045 19.2596 20.7964 19.0691C20.1106 18.8645 19.6929 18.3535 19.5026 17.6591C19.3029 16.9578 19.3141 16.2095 19.5347 15.5151C19.8034 14.67 20.3786 14.204 21.2128 14.0526C21.686 13.9707 22.1708 14.0032 22.6301 14.1474C22.9269 14.2361 22.9491 14.2777 22.9491 14.6052C22.9478 14.7054 22.9393 14.8057 22.9281 14.9721ZM14.4213 7.54282C14.7763 7.62275 15.0992 7.67122 15.4058 7.7707C15.7869 7.89418 15.8025 7.94471 15.8032 8.35595C15.8032 8.88335 15.8032 8.88394 15.3456 8.70515C15.0158 8.57164 14.6636 8.50889 14.31 8.52064C13.9564 8.53239 13.6087 8.61841 13.2877 8.77355C13.0484 8.88394 13.0001 8.85395 12.9903 8.59139C12.985 8.44403 12.9903 8.29595 12.9903 8.14859C12.9864 7.97647 13.0387 7.80809 13.1387 7.67111C13.5354 7.08923 13.9231 6.50254 14.3153 5.9179C14.3513 5.86414 14.3808 5.80823 14.4369 5.72351H13.3956C13.1433 5.72015 13.125 5.69771 13.119 5.42615C13.1158 5.26931 13.119 5.11307 13.119 4.93907C13.1994 4.92267 13.2806 4.91105 13.3622 4.90427H15.4502C15.7326 4.90427 15.7209 4.91051 15.7404 5.21471C15.7561 5.45316 15.6849 5.68899 15.5411 5.87507C15.2005 6.35867 14.8737 6.85319 14.5422 7.34435C14.5004 7.40579 14.4638 7.47263 14.4213 7.54282ZM17.3826 16.7219V14.5389C17.3826 14.2511 17.4094 14.2259 17.6761 14.2197H18.1665C18.3299 14.2197 18.4044 14.3077 18.407 14.4714V18.9737C18.4012 19.1448 18.3129 19.2131 18.1527 19.2069C17.9926 19.2007 17.8258 19.2069 17.6624 19.2069C17.4107 19.1987 17.3839 19.1735 17.3833 18.9081C17.3774 18.1748 17.3826 17.4476 17.3826 16.7219Z",
    fill: "white"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M12.9772 9.53398C13.0262 9.47326 13.0641 9.39202 13.1262 9.35518C13.6873 9.01779 14.3534 8.92515 14.9796 9.09742C15.051 9.10841 15.1155 9.14822 15.1591 9.20829C15.2028 9.26836 15.2221 9.3439 15.2129 9.41866C15.1652 10.1171 14.9579 10.7468 14.4631 11.2461C14.4301 11.2754 14.3925 11.2985 14.3519 11.3143C14.335 11.3219 14.3101 11.3143 14.2454 11.3076C14.2624 11.2223 14.2729 11.1417 14.2958 11.0653C14.4003 10.7085 14.5232 10.3573 14.6102 9.99646C14.6854 9.68602 14.599 9.5653 14.2937 9.55438C13.9669 9.54274 13.6446 9.57142 13.3198 9.58582C13.2178 9.5899 13.1164 9.60418 13.0144 9.61378L12.9772 9.53398ZM17.8506 13.5033C17.4905 13.4876 17.2511 13.2107 17.2715 12.8321C17.2917 12.4536 17.5532 12.2135 17.9219 12.2325C18.2906 12.2516 18.505 12.5142 18.4926 12.9085C18.4801 13.2926 18.2324 13.5204 17.8506 13.5033Z",
    fill: "white"
  })),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("clipPath", {
    id: "clip0_2077_5043"
  },
  /*#__PURE__*/
  React.createElement("rect", {
    width: "23",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Pandora',
  rate: 0.00214,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("path", {
    d: "M19.284 8.9041C19.176 7.8481 18.876 6.8521 18.228 5.9761C17.736 5.3041 17.1 4.8001 16.356 4.4161C15.636 4.0561 14.88 3.8161 14.076 3.7081C13.608 3.6361 13.14 3.6001 12.66 3.6001H5.256C5.208 3.6001 5.172 3.6361 5.172 3.6841V20.2921C5.172 20.3401 5.208 20.3761 5.256 20.3761H9.696C10.092 20.3761 10.416 20.0521 10.428 19.6681V16.4881C10.428 16.4401 10.464 16.4041 10.512 16.4041H11.676C11.964 16.4041 12.264 16.4041 12.552 16.3681C13.488 16.2961 14.436 16.1281 15.324 15.7681C15.6 15.6601 15.876 15.5281 16.152 15.3961C17.232 14.8081 18.048 13.9921 18.624 12.9001C18.9 12.3481 19.092 11.7721 19.212 11.1481C19.284 10.8241 19.32 10.5001 19.332 10.1521V9.2281C19.308 9.1201 19.296 9.0121 19.284 8.9041Z",
    fill: "url(#paint0_linear_2077_5052)"
  }),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint0_linear_2077_5052",
    x1: "2.77404",
    y1: "13.7197",
    x2: "19.1059",
    y2: "7.77538",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#019FEE"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#356DFE"
  }))))
}, {
  name: 'Deezer',
  rate: 0.01039,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("g", {
    clipPath: "url(#clip0_2077_5061)"
  },
  /*#__PURE__*/
  React.createElement("path", {
    d: "M18.7598 16.8206H24V19.8075H18.7598V16.8206Z",
    fill: "url(#paint0_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M0 16.8206H5.24016V19.8075H0V16.8206Z",
    fill: "url(#paint1_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M12.524 16.8206H17.7118V19.8075H12.524V16.8206Z",
    fill: "url(#paint2_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M6.28827 16.8206H11.476V19.8075H6.28827V16.8206Z",
    fill: "url(#paint3_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M18.7598 12.5759H24V15.5629H18.7598V12.5759Z",
    fill: "url(#paint4_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M6.28827 12.5759H11.476V15.5629H6.28827V12.5759Z",
    fill: "url(#paint5_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M6.28827 8.33228H11.476V11.3192H6.28827V8.33228Z",
    fill: "url(#paint6_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M12.524 12.5759H17.7118V15.5629H12.524V12.5759Z",
    fill: "url(#paint7_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M18.7598 8.33228H24V11.3104H18.7598V8.33228Z",
    fill: "url(#paint8_linear_2077_5061)"
  }),
  /*#__PURE__*/
  React.createElement("path", {
    d: "M18.7598 4.19263H24V7.17954H18.7598V4.19263Z",
    fill: "url(#paint9_linear_2077_5061)"
  })),
  /*#__PURE__*/
  React.createElement("defs", null,
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint0_linear_2077_5061",
    x1: "24.5064",
    y1: "18.314",
    x2: "-0.506533",
    y2: "18.314",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.03",
    stopColor: "#1D75B2"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.149",
    stopColor: "#3748AB"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.208",
    stopColor: "#4137A8"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint1_linear_2077_5061",
    x1: "24.5064",
    y1: "18.314",
    x2: "-0.50652",
    y2: "18.314",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.182",
    stopColor: "#244AB9"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.235",
    stopColor: "#4137A8"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.439",
    stopColor: "#A71C81"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.738",
    stopColor: "#EF8907"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#F6A400"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint2_linear_2077_5061",
    x1: "24.5064",
    y1: "18.314",
    x2: "-0.506518",
    y2: "18.314",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.182",
    stopColor: "#244AB9"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.235",
    stopColor: "#4137A8"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.439",
    stopColor: "#A71C81"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.738",
    stopColor: "#EF8907"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#F6A400"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint3_linear_2077_5061",
    x1: "24.5064",
    y1: "18.314",
    x2: "-0.506491",
    y2: "18.314",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.182",
    stopColor: "#244AB9"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.235",
    stopColor: "#4137A8"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.439",
    stopColor: "#A71C81"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.738",
    stopColor: "#EF8907"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#F6A400"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint4_linear_2077_5061",
    x1: "24.5064",
    y1: "14.0695",
    x2: "-0.506533",
    y2: "14.0695",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.03",
    stopColor: "#1D75B2"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.149",
    stopColor: "#3748AB"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.208",
    stopColor: "#4137A8"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint5_linear_2077_5061",
    x1: "24.5064",
    y1: "14.0695",
    x2: "-0.506491",
    y2: "14.0695",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    stopColor: "#1682B4"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.182",
    stopColor: "#244AB9"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.235",
    stopColor: "#4137A8"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.439",
    stopColor: "#A71C81"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.738",
    stopColor: "#EF8907"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#F6A400"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint6_linear_2077_5061",
    x1: "24.5064",
    y1: "9.8258",
    x2: "-0.506491",
    y2: "9.8258",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.403",
    stopColor: "#B83664"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.636",
    stopColor: "#EF8907"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "1",
    stopColor: "#F6A400"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint7_linear_2077_5061",
    x1: "24.5064",
    y1: "14.0695",
    x2: "-0.506518",
    y2: "14.0695",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.284",
    stopColor: "#4137A8"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.509",
    stopColor: "#A71C81"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint8_linear_2077_5061",
    x1: "21.3799",
    y1: "11.3104",
    x2: "21.3799",
    y2: "4.19263",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.097",
    stopColor: "#1D958D"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.726",
    stopColor: "#29AB70"
  })),
  /*#__PURE__*/
  React.createElement("linearGradient", {
    id: "paint9_linear_2077_5061",
    x1: "21.3799",
    y1: "11.3101",
    x2: "21.3799",
    y2: "4.19215",
    gradientUnits: "userSpaceOnUse"
  },
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.097",
    stopColor: "#1D958D"
  }),
  /*#__PURE__*/
  React.createElement("stop", {
    offset: "0.726",
    stopColor: "#29AB70"
  })),
  /*#__PURE__*/
  React.createElement("clipPath", {
    id: "clip0_2077_5061"
  },
  /*#__PURE__*/
  React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))))
}, {
  name: 'Tidal',
  rate: 0.008,
  icon:
  /*#__PURE__*/
  React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /*#__PURE__*/
  React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9336 4.06475L7.83336 8.06398L11.7664 3.96851L15.8245 8.0095L11.8956 11.9853C10.6045 10.6139 9.31353 9.24228 8.02272 7.87054L4.00764 12.062L0 7.91098C1.20384 6.73391 2.55084 5.41655 3.9336 4.06475ZM11.8981 12.2441C13.1348 13.4855 14.437 14.7929 15.7334 16.0946C14.4046 17.4065 13.0781 18.7155 11.7445 20.0318L7.94184 16.1112L11.8981 12.2441ZM16.1862 7.91986C17.4904 6.62753 18.7945 5.33509 20.0984 4.04255C21.4003 5.34599 22.7328 6.68062 24 7.94914L20.1347 11.8723L16.1862 7.91986Z",
    fill: "white"
  }))
}];
export { stores };